export function groupShoppingItems(items, stapleNames = []) {
  const groups = {
    produce: [],
    meat: [],
    dairy: [],
    bakery: [],
    cupboard: [],
    frozen: [],
    other: []
  };

  const produceKeywords = ["broccoli","onion","pepper","carrot","spinach","apple","banana","lettuce","tomato","cucumber","courgette","mushroom","potato","sweet potato","lemon","lime","avocado","berries","grapes","orange","mango","celery","asparagus","kale","cabbage","leek","parsnip","beetroot","corn","peas","green beans","spring onion","chilli","salad"];
  const meatKeywords = ["chicken","beef","pork","fish","salmon","tuna","lamb","turkey","bacon","sausage","mince","steak","prawns","shrimp","ham","duck","chorizo","pancetta","cod"];
  const dairyKeywords = ["milk","cheese","yogurt","egg","eggs","butter","cream","cheddar","mozzarella","parmesan","feta","cream cheese","sour cream","creme fraiche","greek yogurt"];
  const bakeryKeywords = ["bread","bagel","wrap","roll","bun","croissant","pitta","naan","tortilla","crumpet"];
  const cupboardKeywords = ["rice","pasta","spaghetti","noodles","beans","lentils","sauce","tinned","canned","jar","oats","cereal","crackers","biscuits","flour","sugar","stock"];
  const frozenKeywords = ["frozen","ice cream","sorbet"];

  items.forEach((item) => {
    if (!item || typeof item !== "string") return;
    const lower = item.toLowerCase().trim();

    // Skip staples — they appear in the Kitchen Staples section instead
    if (stapleNames.length > 0 && stapleNames.some(s => lower.includes(s) || s.includes(lower))) return;

    if (produceKeywords.some(k => lower.includes(k))) groups.produce.push(item);
    else if (meatKeywords.some(k => lower.includes(k))) groups.meat.push(item);
    else if (dairyKeywords.some(k => lower.includes(k))) groups.dairy.push(item);
    else if (bakeryKeywords.some(k => lower.includes(k))) groups.bakery.push(item);
    else if (cupboardKeywords.some(k => lower.includes(k))) groups.cupboard.push(item);
    else if (frozenKeywords.some(k => lower.includes(k))) groups.frozen.push(item);
    else groups.other.push(item);
  });

  Object.keys(groups).forEach(key => {
    if (groups[key].length === 0) delete groups[key];
  });

  return groups;
}